import React, { useState, useEffect } from 'react';
import qs from 'querystring';
import { useMutation, Query } from 'react-apollo';
import {
  ADD_COMMENT,
  GET_COMMENTS,
  UPDATE_SCHOOL,
} from 'graphql/student_college';
import useSnack from 'hooks/useSnack';
import { toUserTimezone } from 'utils';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Divider,
} from '@material-ui/core';
import Card from './Card';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { useSelector } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ResearchCard from './ResearchCard';
import CloseIcon from '@material-ui/icons/Close';
import { API } from 'aws-amplify';
import Costs from '../components/Costs';
import Retention from '../components/Retention';
import AidAndDebt from '../components/AidAndDebt';
import Salary from '../components/Salary';
import StudentBody from '../components/StudentBody';
import TestScores from '../components/TestScores';
import Spin from 'components/common/Spin';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

const NavTab = withStyles((theme) => ({
  root: {
    minWidth: 72,
  },
}))(Tab);

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    width: '90%',
    height: '90%',
  },
  container: {
    paddingLeft: '30px',
    paddingRight: '30px',
    overflowY: 'scroll',
    height: '88%',
  },
  close: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  }
}));

const Schools = ({ student, schools, addSchool, ...other }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const snack = useSnack();
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('1');
  const [currentSchool, setCurrentSchool] = useState(null);
  const [college, setCollege] = useState(null);

  useEffect(() => {
    if(currentSchool){
      setLoading(true);
      API.get('api', `/college/${currentSchool.id}`).then((data) => {
        setCollege(data);
        setLoading(false);
      });
    }
  }, [currentSchool]);

  const handleModalOpen = (school) => {
    setModalOpen(true);
    setCurrentSchool(school);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setCurrentSchool(null);
    setCollege(null);
    setTab('1');
  };

  return (
    <Box>
      {schools?.map((school) => (
        <Box onClick={()=>handleModalOpen(school)}>
          <Card
            key={school.id}
            student={student}
            data={school}
            user={user}
            addSchool={addSchool}
            {...other}
          />
        </Box>
      ))}
      <Box>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={modalOpen}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 200,
          }}
        >
          <Fade in={modalOpen}>
            <Box className={classes.paper}>
              
              <Box className={classes.close}>
                <IconButton onClick={handleModalClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <Box className={classes.container}>
                {
                  loading ? (
                    <Spin spinning linear />
                  ) : ''
                }

                {currentSchool && !loading && <ResearchCard
                  student={student}
                  data={currentSchool}
                  user={user}
                  addSchool={addSchool}
                  {...other}
                />}

                <Divider />

                {!loading && <Box marginTop={3} marginBottom={3}>
                  <Tabs
                    value={tab}
                    onChange={(e, v) => setTab(v)}
                    indicatorColor="primary"
                    textColor="primary"
                  >
                    <NavTab value={'1'} label="College Info" />
                  </Tabs>
                </Box>}

                {tab === '1' ? (
                  <>
                    {college && !loading &&
                      <Box>
                        <Costs school={college} />
                        <Retention school={college} />
                        <AidAndDebt school={college} />
                        <Salary school={college} />
                        <StudentBody school={college} />
                        <TestScores school={college} />
                    </Box>}
                  </>
                ) : (
                  <></>
                )}

              </Box>

            </Box>
          </Fade>
        </Modal>
      </Box>
    </Box>
  );
};

export default Schools;
